import React from 'react';
import {shallowEqual, useSelector} from "react-redux";

function Geoportail(props){

    const geoportail = useSelector(state => state.geoportailApiReducer.geoportail , shallowEqual)

    const google = window.google;
    const map = props.map;
    let geoportailData;


    function geoportailMap(map) {
        if(map != null){
            if(geoportail){
                geoportailData = new google.maps.ImageMapType({
                    maxZoom: 19,
                    minZoom: 0,
                    name: "Geoportail",
                    tileSize: new google.maps.Size(256, 256),
                    getTileUrl: function (coordinates, zoom) {
                         //Pour DEV
                        return 'https://wxs.ign.fr/an7nvfzojv5wa96dsga5nk8w/geoportail/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&&LAYER=ORTHOIMAGERY.ORTHOPHOTOS&TILEMATRIXSET=PM&TILEMATRIX=' + zoom + '&TILECOL=' + coordinates.x + '&TILEROW=' + coordinates.y +'&STYLE=normal&FORMAT=image/jpeg';

                        // Pour PROD
                        //return 'https://wxs.ign.fr/0skh99buqiuj9k125e4d5q9h/geoportail/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&&LAYER=ORTHOIMAGERY.ORTHOPHOTOS&TILEMATRIXSET=PM&TILEMATRIX=' + zoom + '&TILECOL=' + coordinates.x + '&TILEROW=' + coordinates.y +'&STYLE=normal&FORMAT=image/jpeg';
                    }
                });
                map.overlayMapTypes.insertAt(0, geoportailData);
            }else{
                map.overlayMapTypes.forEach(function (object, index) {
                    map.overlayMapTypes.removeAt(index, geoportailData);
                });
            }
        }
    }


    return(
        <div>
            {geoportailMap(map)}
        </div>
    )
}
export default React.memo(Geoportail);